import { render } from "./TopBox.vue?vue&type=template&id=51a9fa68"
import script from "./TopBox.vue?vue&type=script&lang=js"
export * from "./TopBox.vue?vue&type=script&lang=js"

import "./TopBox.vue?vue&type=style&index=0&id=51a9fa68&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__